export default "__VITE_ASSET__DpSsNqp2__"